module.exports = __webpack_public_path__ + "static/media/unspecified.40fa30d1.svg";